<template>
  <div>
    <ul class="file-path-track">
      <li v-for="(v, index) in trunk" :key="v.id" @click="pathTrackClick(index, v)">
        <span>{{ v.name }}</span>
        <i class="gap-10" v-if="index !== trunk.length - 1">></i>
      </li>
    </ul>
    <div class="list-header space-20">
      <div>
        <a-button  data-ga-id="文档-共享云盘-点击上传" type="primary" @click="showModel = 'addfile'" v-if="!searchStatus">上传</a-button>
        <a-button 
          class="gap-l-10 " 
          data-ga-id="文档-共享云盘-点击新建文件夹"
          type="primary" @click="showModel = 'addFolder'" v-if="!searchStatus">
          新建文件夹
        </a-button>
      </div>
      <a-input-search @search="handleSearch" placeholder="按文件名搜索" v-model="keyword" style="width: 200px" />
    </div>
    <div class="table-box">
      <a-table :loading="loading" :columns="columns" :dataSource="list" :rowKey="row => row.id" :pagination="false" @change="handleTableChange">
        <span data-ga-id="文档-共享云盘-点击文件" class="list-name" slot="name" slot-scope="row" @click="handleFolderClick(row)">
          <a-icon v-if="row.folder" type="folder"></a-icon>
          <file-icon :type="row.fileSuffix" v-else />
          <a-tooltip style="width: 200px;">
            <template slot="title">{{ row.catalog }}</template>
            <span v-if="row.folder" class="gap-l-10">{{ row.name | longText }}</span>
            <a v-else href="javascript:;" @click="handleFileView(row)">{{ row.name | longText }}</a>
          </a-tooltip>
          <span v-if="row.folder" class="text-info">({{ row.fileNum }})</span>
        </span>
        <div slot="action" slot-scope="row">
          <a-button
            :class="{ 'row-hidden': !row.canEdit }"
            :disabled="!folderDeletePermission(row) && row.folder"
            @click="handleDelete(row)"
            size="small"
            type="danger"
             data-ga-id="文档-共享云盘-点击文件操作-删除"
            >删除</a-button
          >

          <!--前没有删除，后没有重命名，就隐藏-->
          <a-divider :class="{ 'row-hidden': !row.canEdit || !row.canEdit }" type="vertical" />

          <a-button
            :class="{ 'row-hidden': !row.canEdit }"
            @click="
              showModel = 'editRename';
              currentRow = row;
            "
            size="small"
             data-ga-id="文档-共享云盘-点击文件操作-重命名"
            >重命名</a-button
          >

          <!--前没有重命名，后没有权限也没有下载，就隐藏-->
          <a-divider type="vertical" :class="{ 'row-hidden': (!row.canOperate && !row.canDownload) || !row.canEdit }" />

          <!--权限是文件夹才有的，下载是文件才有的-->
          <a-button
            v-if="row.folder && row.canOperate"
            :class="{ 'row-hidden': !row.canOperate }"
            @click="changePermission(row)"
            size="small"
            type="primary"
            v-show="row.level && row.level <= 2"
             data-ga-id="文档-共享云盘-点击文件操作-权限"
            >权限</a-button
          >
          <a-button  data-ga-id="文档-共享云盘-点击文件操作-下载" v-else-if="!row.folder && row.canDownload" @click="handleFileDownload(row)" size="small" type="primary">下载</a-button>
          <a-button v-else size="small" class="row-hidden">占位</a-button>
        </div>
      </a-table>
    </div>
    <a-pagination
      class="pagination"
      @change="handlePageChange"
      :defaultPageSize="pagination.pageSize"
      v-model="pagination.page"
      :total="pagination.total"
    ></a-pagination>

    <a-modal title="重命名" :visible="showModel === 'editRename'" width="400px" :footer="null" @cancel="hideModel">
      <a-input-search v-model="currentRow.name" @search="handleRename">
        <a-button slot="enterButton" type="primary">确认</a-button>
      </a-input-search>
    </a-modal>
    <a-modal title="新建文件夹" :visible="showModel === 'addFolder'" width="400px" :footer="null" @cancel="hideModel">
      <a-input-search v-model="newFolder.dirName" @search="handleMkFolder" placeholder="文件夹名称">
        <a-button slot="enterButton" type="primary">确认</a-button>
      </a-input-search>
    </a-modal>
    <a-modal
      :title="`上传文件至${trunk[trunk.length - 1].id}：${trunk[trunk.length - 1].name}`"
      :visible="showModel === 'addfile'"
      width="400px"
      @cancel="
        hideModel();
        getRowFile(trunk[trunk.length - 1]);
      "
      v-if="showModel === 'addfile'"
    >
      <file-upload v-if="showModel === 'addfile'" :folderId="trunk[trunk.length - 1].id" />
      <a-button
        @click="
          hideModel();
          getRowFile(trunk[trunk.length - 1]);
        "
        type="primary"
        slot="footer"
        >确认</a-button
      >
    </a-modal>
    <a-modal :title="`${currentRow.name}的权限设置`" :visible="showModel === 'permission'" width="400px" @ok="handleEditAuthType" @cancel="hideModel">
      <a-select v-model="currentRow.authType" style="width: 120px; margin-bottom: 10px;" :options="options" />
      <folder-permission-set v-if="showModel === 'permission'" ref="permission" :authType="currentRow.authType" :fileId="currentRow.id" />
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { fileSuffix } from '@/const/common.js';
import { downloadFile } from 'assets/js/download';
import fileIcon from '@/components/base/fileIcon';
import FileUpload from '@/components/document/FileUpload';
import FolderPermissionSet from '@/components/document/FolderPermissionSet';
import {
  fileFoldersList,
  fileFoldersDelete,
  fileFoldersAdd,
  fileFoldersRename,
  fileList,
  folderSetPermissionUsers,
  fileFoldersDefaultPermission
} from '@/api/document.js';
import { downloadFile as downloadFileApi } from '@/api/common';
const columns = [
  {
    title: '名称',
    key: 'name',
    scopedSlots: { customRender: 'name' },
    width: 320,
    sorter: true
  },
  {
    title: '上传人',
    customRender: (text, record) => {
      return record.creator;
    },
    align: 'center',
    width: 115
  },
  { title: '大小', dataIndex: 'sizeDesc', align: 'center', width: 100 },
  {
    title: '创建时间',
    key: 'createAt',
    dataIndex: 'createAt',
    align: 'center',
    width: 200,
    sorter: true
  },
  {
    title: '操作',
    align: 'center',
    scopedSlots: { customRender: 'action' },
    width: 260
  }
];
const options = [
  { value: 0, label: '默认' },
  { value: 1, label: '自定义' }
];
export default {
  components: { FileUpload, FolderPermissionSet, fileIcon },
  data() {
    return {
      options,
      trunk: [],
      showModel: '',
      columns,
      list: [],
      loading: false,
      keyword: '',
      searchStatus: false,
      pagination: { page: 1, total: 0, pageSize: 100 },
      sorter: {},
      currentRow: {},
      newFolder: {
        dirName: '',
        folderId: ''
      }
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'token'])
    //返回当前所在folder对应的row
  },
  filters: {
    longText(text) {
      return text.length > 40 ? text.substr(0, 40) + '····' : text;
    }
  },
  methods: {
    async changePermission(row) {
      this.showModel = 'permission';
      this.currentRow = row;
      const res = await fileFoldersDefaultPermission({ fileId: this.currentRow.id });
      if (res.code === 200) {
        this.currentRow.authType = res.data.authType;
      }
    },
    folderDeletePermission(row) {
      const { nickname, roles } = this.userInfo || {};
      const isAdmin = roles.some(item => item.name === 'admin');
      return isAdmin || nickname === row.creator;
    },
    handleFileView(row) {
      let type = row.fileSuffix;
      let temp = fileSuffix.filter(item => item.strs.indexOf(type) > -1);
      if (!temp[0]) {
        temp = [{ type: null }];
      }
      if (temp[0].type === 'video') {
        type = temp[0].type + '/' + type;
      } else {
        type = temp[0].type;
      }
      if (temp[0].type === 'pdf') {
        localStorage.setItem('download', row.canDownload);
        window.open(window.location.origin + `/pdfview/knowledgeFile?id=${row.id}`);
      } else {
        window.open(window.location.origin + `/pdfview/knowledgeFile?id=${row.id}`);
      }
    },
    handleFileDownload(row) {
      downloadFileApi({
        fileType: 'knowledgeFile',
        fileId: row.id
      }).then(res => {
        if (res.code === 200) {
          const downloadPath = res.data + '?Authorization=' + this.token;
          downloadFile(downloadPath);
        }
      });
    },
    handleSearch(value) {
      // 搜索
      this.$ga.gaUploadCustomEvent('文档-共享云盘-搜索文件名');
      this.keyword = value;
      this.pagination.page = 1;
      this.getRowFile(this.trunk[this.trunk.length - 1]);
    },
    hideModel() {
      this.showModel = '';
    },
    async handleEditAuthType() {
      // 文件夹-保存权限(默认/自定义)
      let canViewUserIds = [],
        canDownloadUserIds = [],
        canOperateUserIds = [];
      let permission = +this.currentRow.authType === 0 ? this.$refs.permission.permission : this.$refs.permission.customPermission;
      permission.forEach(item => {
        if (+item.fileTypeId === 0) {
          item.users.forEach(user => {
            canViewUserIds.push(user.id);
          });
        } else if (+item.fileTypeId === 1) {
          item.users.forEach(user => {
            canDownloadUserIds.push(user.id);
          });
        } else if (+item.fileTypeId === 3) {
          item.users.forEach(user => {
            canOperateUserIds.push(user.id);
          });
        }
      });
      const res = await folderSetPermissionUsers({
        fileId: this.currentRow.id,
        isDefault: +this.currentRow.authType === 0,
        canViewUserIds: canViewUserIds.join(','),
        canDownloadUserIds: canDownloadUserIds.join(','),
        canOperateUserIds: canOperateUserIds.join(',')
      });
      if (res.code === 200) {
        this.$message.success('保存成功');
        this.hideModel();
      }
    },
    handleDelete(row) {
      // 删除
      this.$confirm({
        title: `确定删除${row.folder ? '文件夹' : '文件'}：${row.name}吗`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          fileFoldersDelete(row.id).then(res => {
            if (res.code === 200) {
              this.$message.success(res.data || 'success');
              this.getRowFile(this.trunk[this.trunk.length - 1]);
            }
          });
        }
      });
    },
    handleRename() {
      // 重命名
      let query = { name: this.currentRow.name, fileId: this.currentRow.id };
      fileFoldersRename(query).then(res => {
        if (res.code === 200) {
          this.$message.success(res.data || 'success');
          this.hideModel();
        }
      });
    },
    handleMkFolder() {
      // 创建文件夹
      this.newFolder.folderId = this.trunk[this.trunk.length - 1].id;
      fileFoldersAdd(this.newFolder).then(res => {
        if (res.code === 200) {
          this.$message.success(res.data || 'success');
          this.hideModel();
          this.newFolder = { dirName: '', folderId: '' };
          this.getRowFile(this.trunk[this.trunk.length - 1]);
        }
      });
    },
    handleFolderClick(row) {
      // 点击文件夹-点击文件不会执行
      if (row.folder) {
        this.keyword = '';
        this.pagination.page = 1; // 进入下一级文件夹 初始化分页 为第一页
        // this.$router.push(`/document?rowId=${row.id}`)
        this.getRowFile(row);
      }
    },
    getRowFile(row) {
      // 获取表格数据-文件/文件夹
      if (this.loading) {
        return;
      }
      if (this.keyword.length) {
        this.searchStatus = true;
      } else {
        this.searchStatus = false;
      }
      this.loading = true;
      let query = Object.assign({ searchName: this.keyword }, this.pagination);
      if (this.sorter.columnKey) {
        query.isAsc = this.sorter.order === 'ascend' ? true : false;
        query.sortField = this.sorter.columnKey;
      }
      row && (query.folderId = row.id);
      query.pageSize = this.pagination.pageSize;
      localStorage.setItem('fileListQuery', JSON.stringify(query));
      fileList(query).then(res => {
        this.loading = false;
        if (res.code === 200) {
          this.list = res.data.list;
          this.pagination.page = res.data.page;
          this.pagination.total = res.data.total;
          this.trunk = res.data.trunk;
        }
      });
    },
    pathTrackClick(index, v) {
      // 顶部路径点击执行
      this.pagination.page = 1;
      this.keyword = '';
      this.getRowFile({ id: v.id });
    },
    handlePageChange(page, pageSize) {
      this.pagination.page = page;
      this.getRowFile(this.trunk[this.trunk.length - 1]);
    },
    handleTableChange(pagination, filters, sorter) {
      this.sorter = sorter;
      this.getRowFile(this.trunk[this.trunk.length - 1]);
    }
  },
  mounted() {
    //判断页面是刷新的，还是路由切换的
    if (localStorage.getItem('isUnload') === 'true') {
      const query = JSON.parse(localStorage.getItem('fileListQuery'));
      fileList(query).then(res => {
        this.loading = false;
        if (res.code === 200) {
          this.list = res.data.list;
          this.pagination.page = res.data.page;
          this.pagination.total = res.data.total;
          this.trunk = res.data.trunk;
        }
      });
      localStorage.setItem('isUnload', false);
    } else {
      this.getRowFile();
    }

    // this.listenBackBtnInit();
    //标识页面刷新，存入localstorage
    window.onunload = () => {
      localStorage.setItem('isUnload', true);
    };
  },
  destroyed() {
    window.removeEventListener('popstate', this.listenBackBtn, false);
  }
};
</script>

<style lang="less" scoped>
.list-name {
  cursor: pointer;
}
.list-header {
  display: flex;
  justify-content: space-between;
}
.pagination {
  float: right;
  margin: 10px;
}
.file-path-track {
  display: flex;
  li {
    font-size: 14px;
    span {
      cursor: pointer;
    }
  }
}
.row-hidden {
  visibility: hidden;
}
.table-box {
  width: 100%;
  overflow-x: scroll;
}
</style>
